'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exitIntentTriggerEnabled = undefined;

var _getMessage = require('conversations-schema/operators/widget-data/getMessage');

var _getClientTriggers = require('conversations-schema/operators/message/getClientTriggers');

var _clientTriggersGetters = require('conversations-schema/client-triggers/operators/clientTriggersGetters');

var _exitIntentTriggerGetters = require('conversations-schema/client-triggers/operators/exitIntentTriggerGetters');

var exitIntentTriggerEnabled = exports.exitIntentTriggerEnabled = function exitIntentTriggerEnabled(widgetData) {
  var message = (0, _getMessage.getMessage)(widgetData);
  var clientTriggers = (0, _getClientTriggers.getClientTriggers)(message);
  var displayOnExitIntent = (0, _clientTriggersGetters.getDisplayOnExitIntent)(clientTriggers);
  var enabled = (0, _exitIntentTriggerGetters.getEnabled)(displayOnExitIntent);

  return enabled;
};